(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-promo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const pill = event.target.closest('.product-promo__pill[data-product-promo-url]');
    if (!pill) return;

    const root = pill.closest('[data-product-promo]');
    if (!root) return;

    root.querySelectorAll('.product-promo__pill[aria-pressed]').forEach((item) => {
      item.setAttribute('aria-pressed', item === pill ? 'true' : 'false');
    });

    const cta = root.querySelector('[data-product-promo-cta]');
    if (cta) cta.setAttribute('href', pill.dataset.productPromoUrl);
  });

  } catch(e) { console.error(e); }
})();
})();
